import { lazy } from "react"

export const LazyRiver = lazy(() => import(".").then(module => ({ default: module.LazyRiver })))
